export default "__VITE_ASSET__BBxxoWt2__"